import { MouseEvent } from 'react';
import { Features } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import { hasFeature } from 'modelInterface/features/featureInterface';
import { openSidebarPanel } from 'canvas/sidebarPanel/actions';
import { SidebarPanelContentIds } from 'canvas/sidebarPanel/types';
import { showViewSidePanel } from 'views/mainApp/viewSidePanel/actions';
import { ViewSidePanelContentIds } from 'views/mainApp/viewSidePanel/types';

export const openViewSettingsPanel = (event: MouseEvent): void => {
  event.stopPropagation();

  if (hasFeature(Features.CANVAS_PROTOTYPE)) {
    dispatchAction(openSidebarPanel(SidebarPanelContentIds.VIEW_SETTINGS));
    return;
  }

  dispatchAction(showViewSidePanel(ViewSidePanelContentIds.VIEW_OPTIONS));
};
